// Re-export Display as the default Show component for backwards compatibility
export { HostKaraokeDisplay as HostKaraokeShow } from './display'
